export default __webpack_public_path__ + "static/media/midstayClean.13454b49.jpg";